















import { Vue, Component } from "@/shared/vuepack";
@Component({
  components: {
  }
})
export default class ElementsFormsInstructions extends Vue {

}
